import { handleWordClick } from '../../utils/phraseBusinessLogic';
import { BlockWords } from './BlockWords';

/**
 * Container para as palavras que precisam ser completadas
 * Agora itera sobre blocos ao invés de palavras individuais
 * @param {Object} props
 * @param {Array} props.blocks - Array de blocos com words
 */
export const ToCompleteWordsContainer = ({ blocks }) => (
  <>
    {blocks.map((block, index) => (
      <BlockWords
        key={`block-${index}`}
        block={block}
        onWordClick={handleWordClick}
      />
    ))}
  </>
);
